import React from 'react';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import IntegrationReactSelectNew from './IntegrationReactSelectNew';
import InputBox from './InputBox';
import _ from 'lodash';
import SnackBar from './SnackBar';

import '../css/OkasBoxesEdit.css';
import ErrorText from '../ErrorText';


//okasboxes edit page

const customStyles = {
  content : {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minHeight: '10%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '40px 90px 40px 90px',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
    // background: 'none !important'
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};


const customStylesSuccess = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    minHeight: '50%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '2%',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};

const ObType = [

];


export default class OkasBoxesEdit extends React.Component{
  constructor(props) {
  super(props);

  this.state = {
    modalIsOpen: this.props.activeModal,
    modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
    modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
    ObType: this.props.ObCurrentData.okasBox_type,
    // ObSerialNo: this.props.ObCurrentData.okasBox_serialNo,
    ObRegistrationId: this.props.ObCurrentData.okasBox_serialNo,
    ObLicenseId: this.props.ObCurrentData.okasBox_version,
    ObDate:this.props.ObCurrentData.created_at,
    errorMessage: [],
    modalIsOpenSuccess: false,
    showErrorMessage: false,
    OBAvailable: true,
    publicVersion: [],
    disableButton: true,
    snackbarActive: false,
    snackbarMessage: '',

  };
  this.openModal = this.openModal.bind(this);
  this.afterOpenModal = this.afterOpenModal.bind(this);
  this.closeModal = this.closeModal.bind(this);
  this.closeModalSuccess = this.closeModalSuccess.bind(this);

}

openModal() {
  this.setState({modalIsOpen: true});
}    
closeModalSuccess() {
  this.setState({
    modalIsOpenSuccess: false
  });
}

closeModalSuccess() {
  this.setState({
    modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp'
  },()=>{
    setTimeout(()=>{
      this.props.refreshDevices()
      this.setState({
        modalIsOpenSuccess: false
      })
    }, 500);

  })
}
afterOpenModal() {
  // references are now sync'd and can be accessed.
  // this.subtitle.style.color = '#f00';
}

closeModal() {
  this.setState({
    modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
  },()=>{
    setTimeout(()=>{
      this.props.refreshDevices()
      this.setState({
        modalIsOpen: false
      })
    }, 500);

  })
}

onSelectChange = (operationMode, valueSelect) => {
  if (operationMode === 'obType') {
    this.setState({
      ObType: valueSelect.value,
      disableButton: false,
      errorMessage: []
    })
  } else if (operationMode === 'obVersion') {
    this.setState({
      ObLicenseId: valueSelect.value,
      errorMessage: [],
      disableButton: false
    })
  }
}

componentDidMount(){
    this.fecthAllSI();
    this.fetchPublicVersion()
}

fecthAllSI = ()=>{
  var tokenStored = localStorage.getItem('token');
  tokenStored = `Token ${tokenStored}`;
  var headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'X-CSRFToken': localStorage.getItem('csrftoken'),
    'Authorization': tokenStored
}
  fetch('/cloud/si_IntegratorApi/' ,{
          method: "GET",
          headers: headers,
      })
                   .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
.then(data => {
  this.setState({
    obData: data
  },()=>console.log(this.state))
})
.catch((err)=>{
  console.log(err)
})
}


AddingOB = () => {
  let okasBox_type = this.state.ObType;
  // let okasBox_serialNo = this.state.ObSerialNo;
  let okasBox_serialNo = this.state.ObRegistrationId;
  let okasBox_version = this.state.ObLicenseId;
  let created_at = this.state.ObDate;
  console.log(this.state)
  
  var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
  }

    fetch(`/cloud/okasBoxApi_Detail/${this.props.ObCurrentData.okasBox_id}` ,{
            method: "PUT",
            headers: headers,
            body: JSON.stringify({
              okasBox_type,              
              okasBox_serialNo,
              okasBox_version,
                  })
        })
           .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
  .then(data => {
    console.log(data)
   let rawData = data;
    data=data.data
    let index = Object.keys(data)[0]
    console.log(index + ": " + data[Object.keys(data)[0]])
   let  errorLog = index + ": " + data[Object.keys(data)[0]]
    if(rawData.message!=="failure"){
      this.setState({
        modalIsOpen:false,
        modalIsOpenSuccess:true,
        obData: data
      })
    }else{
      this.setState({
        snackbarMessage: errorLog,
        snackbarActive: true
      })
    }
  })
  .catch((err)=>{
    console.log(err)

  })
  ;
}


AddOB = () => {
  this.setState({
    showErrorMessage: true
  },()=>{
    this.fetchError((e)=>{
     if(e==='NoError'){
       this.AddingOB();
     }
    })
  })
}

checkOBSerialNo = (e) =>{
  let data = '';
  this.state.obData.forEach((e)=>{
    if(e.si_userName===this.state.ObRegistrationId){
    data = 'username exist';
    }
  })
  if(data==='username exist'){
    this.setState({
      OBAvailable:false
    })
  }
}
fetchError = (noError) => {
  var totalError = 3;
  if (ErrorText('notEmpty', this.state.ObType) === 'No Error') {
    totalError = totalError - 1;
  }

  if (ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId.trim()) === 'No Error') {
    totalError = totalError - 1;
  }

  if (ErrorText('notEmpty', this.state.ObLicenseId.trim()) === 'No Error') {
    totalError = totalError - 1;
  }

  if (totalError === 0) {
    noError('NoError');
  }
}




handleChangeInputBox = (name, event) => {
  this.setState({
    [name]: event,
    disableButton: false
  },()=>{
    if(name==='ObSerialNo'){
      this.checkOBSerialNo()
    }

  });
};

fetchPublicVersion = () => {
  var tokenStored = localStorage.getItem('token');
  tokenStored = `Token ${tokenStored}`;
  var headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'X-CSRFToken': localStorage.getItem('csrftoken'),
    'Authorization': tokenStored
  }
  fetch('/cloud/okasVersionApi/', {
    method: "GET",
    headers: headers,
  })
             .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
    .then(data => {
      if (data.detail === 'Invalid token.') {
        localStorage.clear();
      } else {
        console.log(data)
        let publicVersion = [];
        data.forEach((sumValue) => {
          publicVersion.push({ label: sumValue.major.okas_product_version })
        })
        this.setState({ publicVersion })
      }
    })
    .catch((err)=>{
      console.log(err)
    })
}

   render(){
    const dateFromString = new Date(this.state.ObDate);
      const dateOnly = dateFromString.toISOString().split('T')[0];
        return (
          <React.Fragment>
             <SnackBar open={this.state.snackbarActive} handleSnackbarClose={()=>{    this.setState({
      snackbarActive: false
    })}} message={this.state.snackbarMessage}/>
            <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          className={this.state.modalStateAftereOpen} 
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
                <i class="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase" style={{ color: '#888888', fontSize: '30px',marginBottom: '30px'}} >Edit OKAS Box</h3>
          <div className="row" style={{margin: '0px'}}>
          <div className="col-6 text-field-modal pl-0 disableEvent" >
              <IntegrationReactSelectNew 
              placeholder=""
              multipleSelect={false}
              content={ObType}
              onSelect={this.onSelectChange.bind(this,'obType')}
              IntegrationReactSelectNewLabel = "Box Type"
              errorText={this.state.ObType==='' && this.state.showErrorMessage ? 'Please select the Box Type' : ''}
              someText = {this.state.ObType}          
              disableEvent={true}  
              />
            </div> 
            <div className="col-6 text-field-modal pl-0 " >
              <IntegrationReactSelectNew
                placeholder=""
                multipleSelect={false}
                content={this.state.publicVersion}
                onSelect={this.onSelectChange.bind(this, 'obVersion')}
                IntegrationReactSelectNewLabel="Box Version"
                errorText={this.state.ObLicenseId === '' && this.state.showErrorMessage ? 'Please select the Box Version' : ''}
                someText = {this.state.ObLicenseId}  
              />
            </div>
            <div className="col-6 pl-0" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
              <InputBox
                inputText={this.state.ObRegistrationId}
                error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId.trim()) !== 'No Error' && this.state.showErrorMessage ? true : false}
                errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId.trim()) !== 'No Error' && this.state.showErrorMessage ? 'Please enter a valid Serial No. of 6-16 alphanumeric characters' : ''}
                placeholder="Serial No"
                inputBoxName="ObRegistrationId"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={16}
                validate={true}
              />
            </div> 
            <div className="col-6 pl-0 disableEvent" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
             <InputBox 
               inputText={dateOnly}
              //  error={ErrorText('isOkasBoxSerialNumber', this.state.ObDate)!=='No Error' && this.state.showErrorMessage  ? true : false}
              //  errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObDate)!=='No Error' && this.state.showErrorMessage ? 'Registration ID cannot be left blank  and have min 6 in length.' : ''}
               placeholder="yyyy/mm/dd"
               inputBoxName="ObDate"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={16}
                validate={true}
                disableEvent={true} 

               />
             </div> 
          
            </div>
             <div className="float-right" style={{marginTop: '70px', marginBottom: '70px'}}>
             <div className="btn btn-new-grey " onClick={this.closeModal} style={{marginRight: '15px'}} >Close</div>  
               <div className="btn btn-new-green"
                             style={{
                              pointerEvents: this.state.disableButton ? 'none' : '',
                            }}
                onClick={this.AddOB.bind(this)}>Save Changes</div>              
             </div>
        </Modal>
        <Modal
                 isOpen={this.state.modalIsOpenSuccess}
                 style={customStylesSuccess}
                 className={this.state.modalStateAftereOpenSuccess}
                  contentLabel="Example Modal">
              <div className="modal-add-device">
                <div className="float-right cross-times" onClick={this.closeModalSuccess}>
                  <i className="fas   fa-2x mr-2"></i>
                </div>
              </div>
            <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">OKAS Box edited successfully.</h3>
                <i class="fas fa-check-circle update"></i>
                <br/>
                <div className="btn reset-btn mx-2 px-5"
                  onClick={(e)=>{
                            // const history = createHistory({forceRefresh: true})
                            window.location.href ='/okasboxes/dashboard'}}>
                              Close 
                            </div>
            </div>
            </Modal> 
          </React.Fragment>
        );
    }
}
